
//Import Breadcrumb
import { Grid, Stack } from "@mui/material";
import { connect } from 'react-redux';
import CustomButton from "../../../components/Form/CustomButton";
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../../components/Form/DatePicker";
import "../../Orders/order.css";

const ContractsFields = ({ setOpenDiscountField, tempDiscount, setError, setTempDiscount, errorSet, edit, setEditId, handleSaveEdit, id, handleAddDiscount, type, contracts }) => {
    return (
        <div className="mt-3">
            <Grid container sx={{ border: '1px solid #e0e0e0', borderRadius: "8px", backgroundColor: "#fafafa" }} p={2} pt={0}>
                <Grid item xs={12} pb={2}>
                    <Stack direction={{ xs: "column-reverse", sm: "row" }} pt={2} gap={1} justifyContent={"space-between"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <i className="ri-contract-line" style={{ fontSize: "24px" }}></i>
                            </div>
                            <div>
                                <span className="setting-form-section-header font-size-14" >New contract</span>
                            </div>
                        </Stack>
                        <div className="d-flex justify-content-end">
                            <CustomButton
                                borderStyle={"1px solid #999999"}
                                title={
                                    <span>
                                        <i className="ri-close-fill me-2"></i>Cancel
                                    </span>
                                }
                                press={() => {
                                    if (edit) {
                                        setEditId();
                                        setTempDiscount(""); setError("")
                                    } else {
                                        setOpenDiscountField(false);
                                        setTempDiscount(""); setError("")
                                    }
                                }}
                                height={26}
                                backgroundColor={'transparent'}
                                textColor={'#999999'}
                            />

                        </div>
                    </Stack>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={tempDiscount?.unique_code ? 6 : 12} style={{ width: "100px" }}>
                        <CustomTextField
                            title={'Contract code'}
                            values={tempDiscount?.code}
                            onChange={(e) => setTempDiscount((prevValues) => ({
                                ...prevValues,
                                code: e,
                            }))}
                            error={errorSet && !tempDiscount?.code && errorSet?.code}
                        />
                    </Grid>
                    {tempDiscount?.unique_code &&
                        <Grid item xs={6} style={{ width: "100px" }}>
                            <CustomTextField
                                title={'Unique Code'}
                                disabled
                                values={tempDiscount?.unique_code}
                            />
                        </Grid>}
                    <Grid item xs={12} sm={6} >
                        <CustomizedDatePicker
                            title={'Contract start'}
                            values={tempDiscount?.start_date && new Date(tempDiscount.start_date)}
                            setFormValues={setTempDiscount}
                            name={'start_date'}
                            error={errorSet && !tempDiscount?.start_date && errorSet?.start_date}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomizedDatePicker
                            title={'Contract end'}
                            values={tempDiscount?.end_date && new Date(tempDiscount.end_date)}
                            setFormValues={setTempDiscount}
                            name={'end_date'}
                            error={errorSet && !tempDiscount?.end_date && errorSet?.end_date}
                        />
                    </Grid>
                </Grid>

            </Grid>
            <div className="pt-3">
                <CustomButton
                    title="Save"
                    press={() => {
                        if (edit) {
                            handleSaveEdit(id);
                        } else {
                            handleAddDiscount();
                        }
                    }}
                    height={40}
                    width="100%"
                    backgroundColor="#101010"
                    textColor="white"
                />

            </div>

        </div >
    );
};

function mapStateToProps({ }) {
    return {

    };
}


export default connect(mapStateToProps)(ContractsFields);
